// TODO: make accordionPanel be part of the event passed in
// TODO: Take functions out of forEach

MicroModal.init();

/**
 * Sets active product thumbnail based on location hash.
 *
 * @return  {undefined}
 */
function setActiveThumbnail() {
  if (!location.hash) return;

  const className = 'product__asset--selected';
  const thumbnails = $('.product__thumbnails .product__asset');
  const imageId = location.hash.substr(1);

  thumbnails.removeClass(className);
  thumbnails.filter(`[data-image-id="${imageId}"]`).addClass(className);
}

/**
 * Initializes Flickity instance for product's mobile carousel
 *
 * @return  {undefined}
 */
function initFlickity() {
  $('.product__flkty').flickity();
}

window.onhashchange = setActiveThumbnail;

$(function() {
  setActiveThumbnail();
  initFlickity();
});
